// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__24jGS","footer":"Form_footer__3Bykr"};